module.exports = __webpack_public_path__ + "img/error.e4bcfea1.svg";